import { Box, Button, Grid, MenuItem, Modal, TextField } from "@mui/material";
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setIsLoading } from "../../../features/datatable/dataTableSlice";

import { createAnalysis } from "../../../utils/computation/analysis";
import { getXBarAndR } from "../../../utils/computation/getXBarAndR";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "25%",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
};

const XBarAndR = ({ title, closeMenu, openModal, setOpenModal }) => {
  //local states
  const [groups, setgroups] = useState("");
  const [samplesPerGroup, setsamplesPerGroup] = useState(0);
  const [seed, setseed] = useState(0);

  //params
  const { documentId } = useParams();

  //dispatch
  const dispatch = useDispatch();

  //redux states
  const { token } = useSelector((state) => state.auth);

  //functions
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    closeMenu();
    setOpenModal(false);
  };

  const createGraph = async () => {
    dispatch(setIsLoading());
    // get the array value of selected columns

    closeMenu();
    let res = await getXBarAndR({
      groups: groups,
      samplesPerGroup: Number(samplesPerGroup),
      seed: Number(seed),
    });

    const graphs = {
      ...res,
      column: title,
      title,
    };

    try {
      const resFromCreateAnalysis = await createAnalysis(
        token,
        documentId,
        graphs
      );
      graphs.id = resFromCreateAnalysis.id;
    } catch (error) {
      return console.log("error", error);
    }
    dispatch(setIsLoading());
  };

  return (
    <Modal
      open={openModal === title}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h1> {title}</h1>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} p={1}>
            <h3> Data Range</h3>
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Groups
            </h3>
            <TextField
              fullWidth
              id="filled-basic"
              variant="filled"
              label="groups"
              sx={{ mt: 1 }}
              type="string"
              onChange={(e) => setgroups(e.target.value)}
            />
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Samples per Group
            </h3>
            <TextField
              fullWidth
              id="filled-basic"
              variant="filled"
              label="Samples per Group"
              sx={{ mt: 1 }}
              defaultValue={0}
              type="number"
              onChange={(e) => setsamplesPerGroup(e.target.value)}
            />
            <h3
              style={{
                marginTop: "10px",
              }}
            >
              Seed
            </h3>
            <TextField
              fullWidth
              id="filled-basic"
              variant="filled"
              label="Seed"
              sx={{ mt: 1 }}
              defaultValue={0}
              type="number"
              onChange={(e) => setseed(e.target.value)}
            />
          </Grid>
        </Grid>
        <div style={{ display: "flex", float: "right", marginTop: "20px" }}>
          <Button
            variant="outlined"
            style={{
              borderRadius: "15px",
            }}
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              width: "auto",
              marginLeft: "10px",
            }}
            onClick={() => createGraph()}
          >
            Run Function
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default XBarAndR;
